module.exports = __webpack_public_path__ + "static/media/1724_2018Gallery.28f11e02.JPG";